import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate, Button, showNotification, refreshView as refreshViewAction } from 'react-admin';
import compose from 'recompose/compose';

import request from '../../../../network/request';
import resourceConfig from './config';

class SendButton extends Component {
    state = {
      executing: false
    }
    handleClick = async() => {
      const {
        showNotification,
        record,
        refreshView,
        bulk = false,
        selectedIds = [],
      } = this.props;

        this.setState({
          executing: true
        });
        let response = null;
        try {
          const requestParams = bulk ? {
            path: '/admin/nkrequest/func/sendDocs',
            urlParams: {
              docIds: selectedIds.join(','),
            },
          } : {
            path: `/admin/nkrequest/func/send?docId=${record.id}`,
          };

          response = await request({
            apiService: 'shoes',
            ...requestParams,
            method: 'POST',
          })
        } catch (e) {
          console.error(e);
        }
        if (response === null || !response.ok) {
          showNotification(`resources.${resourceConfig.name}.send.errorMessage`, 'error');
        } else {
          showNotification(`resources.${resourceConfig.name}.send.successMessage`, 'success');
        }
        
        this.setState({
          executing: false
        }, refreshView);
    };
    

    render() {
        const {
          bulk = false,
          selectedIds = [],
        } = this.props;

        return (
            <Button label={`resources.${resourceConfig.name}.send.action`} disabled={this.state.executing || (bulk && selectedIds.length === 0)} onClick={this.handleClick} />
        );
    }
}

export default compose(
  translate,
  connect(undefined, { 
    showNotification, 
    refreshView: refreshViewAction 
  })
)(SendButton);
